import * as exFile from '../utils/files';
import * as exRequest from '../utils/request';

// ----------------------------------------------------------------------------

async function forReader(arr: string[] | File[], config: Record<string, any> = {}): Promise<any> {
    const listPromise: Promise<any>[] = [];

    // Foreach Array
    for (const item of arr) {
        //
        const fetchPromise = new Promise(function (resolve, reject): any {
            //
            if (item instanceof File) {
                // File reader
                void exFile.reader(item, {
                    merge: config.file,
                    fnSuccess: function (data, evt): any {
                        resolve({
                            file: item,
                            data,
                            evt,
                        });
                    },
                    fnError: reject,
                });
            }
            //
            else if (typeof item === 'string') {
                // Request XHR
                exRequest.xhr({
                    merge: config.url,
                    url: item,
                    responseType: 'arraybuffer',
                    fnSuccess: function (data, evt): any {
                        resolve({
                            url: item,
                            data,
                            evt,
                        });
                    },
                    fnFail: reject,
                });
            }
        });

        // List Promise Push
        listPromise.push(fetchPromise);
    }

    // Return
    return Promise.all(listPromise);
}

// ----------------------------------------------------------------------------

export default forReader;
